<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="ip_code,ip_vendname,ip_remark"
      placeholder="输入单据编号、供应商、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.ip_id"
        :to="'/purchase/price/' + item.ip_id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.ip_code }}</p>
          <p class="list-item-muted">{{ item.ip_successdate }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.ip_vendname }}</p>
          <span
            class="list-item-status"
            :class="{ warning: item.ip_status != '已审核' }"
            >{{ item.ip_status }}</span
          >
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}次</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/purchase/inquiryprice/list",
      filters: [
        {
          type: "date",
          name: "ip_successdate",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "ip_statuscode <> 'AUDITED'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "ip_statuscode = 'AUDITED'",
            },
          ],
        },
      ],
    };
  }
};
</script>